import { host } from '../config/env'
/**
 * 对图片压缩处理
 * @param url
 * @param filePath
 * @param isSupportWebp
 * @param quality
 * @param width
 * @param height
 * @returns {*}
 */
const imageCompress = (
  url,
  filePath,
  isSupportWebp,
  quality,
  width,
  height
) => {
  if (!url) return ''
  // 1.自带http、https或者//的图片
  if (/^(https?:)?\/\//.test(url)) {
    return url.replace(/^https?:\/\//, '//')
  }
  if (!url.startsWith('/')) {
    url = '/' + url
  }
  let webpAttach = ''
  let qualityAttach = ''
  let compoundAttach = ''
  if (isSupportWebp) {
    webpAttach = '/format/webp'
  }
  if (width && !height) {
    compoundAttach = `/thumbnail/${width}x`
  }
  if (height && !width) {
    compoundAttach = `/thumbnail/x${height}`
  }
  if (width && height) {
    compoundAttach = `/crop/${width}x${height}/gravity/north`
  }
  if (quality) {
    qualityAttach = `/quality/${quality}`
  }
  // 2.已经做过一定的处理的图片
  if (url.indexOf('?imageMogr2') > -1) {
    if (filePath) {
      return filePath + url + '|imageMogr2' + qualityAttach + compoundAttach
    } else {
      return url + '|imageMogr2' + qualityAttach + compoundAttach
    }
  }
  const match = /(\.svg)/.test(url)
  if (match) {
    return filePath + url
  }
  return (
    filePath +
    url +
    (url.includes('?') ? '&' : '?') +
    'imageMogr2' +
    webpAttach +
    qualityAttach +
    compoundAttach
  )
}
function completeUrl (url) {
  if (!url) return ''
  // 1.自带http、https或者//的图片
  if (/^(https?:)/.test(url)) {
    return url
  } else if (/^\/\//.test(url)) {
    return window.location.protocol + url
  }
  return window.location.protocol + host.file + '/' + url
}

export default {
  install: function (Vue, name = '$imageCompress') {
    Object.defineProperty(Vue.prototype, name, { value: imageCompress })
  }
}

export { imageCompress, completeUrl }
